import React, { useState } from 'react';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import WelcomePage from './pages/WelcomePage';
import MenuPage from './pages/MenuPage';
import ContactPage from './pages/ContactPage';
import OrderPage from './pages/OrderPage';
import AdminLogin from './pages/admin/AdminLogin';
import AdminDashboard from './pages/admin/AdminDashboard';
import OrderSuccess from './pages/OrderSuccess';
import FryLogForm from './pages/admin/FryLogForm';
import ProtectedRoute from './components/admin/ProtectedRoute';

function App() {
  const [darkMode, setDarkMode] = useState(false);

  return (
    <div className={darkMode ? 'dark' : ''}>
      <div className="min-h-screen bg-pink-50 dark:bg-gray-900 text-black dark:text-white transition-colors">
        <Router>
          <Navbar toggleDark={() => setDarkMode(!darkMode)} dark={darkMode} />
          <Routes>
            <Route path="/" element={<WelcomePage />} />
            <Route path="/menu" element={<MenuPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/admin" element={<AdminLogin />} />
            <Route path="/order" element={<OrderPage />} />
            <Route path="/order-success" element={<OrderSuccess />} />
            <Route
              path="/admin/dashboard"
              element={
                <ProtectedRoute>
                  <AdminDashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/dashboard/new"
              element={
                <ProtectedRoute>
                  <FryLogForm />
                </ProtectedRoute>
              }
            />

            <Route
              path="/admin/dashboard/edit/:id"
              element={
                <ProtectedRoute>
                  <FryLogForm editMode={true} />
                </ProtectedRoute>
              }
            />
          </Routes>
        </Router>
      </div>
    </div>
  );
}

export default App;
